
import Vue, { PropType } from 'vue';
import { BCard, BCardBody, BButton } from 'bootstrap-vue';
import { IStep } from './interfaces/step';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default Vue.extend({
	components: {
		BCard,
		BCardBody,
		BButton,
		FontAwesomeIcon,
	},
	props: {
		steps: {
			type: Array as PropType<Array<IStep>>,
			required: true,
		},
		iconSize: {
			type: String,
			required: false,
			default: '1x',
		},
		completedIcon: {
			type: String,
			required: false,
			default: 'check',
		},
		activeStepBlocked: {
			type: Boolean,
			required: false,
			default: false,
		},
		continueButtonText: {
			type: String,
			required: false,
			default: 'Continue',
		},
		showCancelButton: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			allStepsCompleted: false,
		};
	},
	computed: {
		activeStep(): IStep | undefined {
			if (this.clonedSteps.length > 0) return this.clonedSteps.find((x) => x.active == true);
			return undefined;
		},
		clonedSteps(): IStep[] {
			return this.steps;
		},
	},
	methods: {
		isLastStep(step: IStep | undefined): boolean {
			if (step) return step.id == this.clonedSteps[this.clonedSteps.length - 1].id;
			return false;
		},
		continueToNextStep(): void {
			if (!this.activeStepBlocked) {
				const currentIndex = this.clonedSteps.findIndex((x) => x.id == this.activeStep?.id ?? '');
				if (this.clonedSteps[currentIndex]) {
					if (!this.isLastStep(this.activeStep)) this.clonedSteps[currentIndex].active = false;
					this.clonedSteps[currentIndex].completed = true;
					this.$emit('step-completed', this.activeStep);
					if (this.clonedSteps[currentIndex + 1] && !this.isLastStep(this.activeStep)) {
						this.clonedSteps[currentIndex + 1].active = true;
						this.$emit('next-step', this.clonedSteps[currentIndex + 1]);
					} else if (this.isLastStep(this.activeStep)) {
						this.allStepsCompleted = true;
						this.$emit('all-steps-completed', this.clonedSteps);
					}
				}
			}
		},
	},
});
